import type { ComponentType } from 'react';
import type { AnalyticsDataPayload } from '@atlassian/jira-analytics-web-react/src';
import BaseReduxAnalyticsData, {
	type ConnectOptions,
} from '@atlassian/jira-analytics-web-react/src/components/redux-analytics-data';
import { ff } from '@atlassian/jira-feature-flagging';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { IssueTableContext } from '../../state/store';
import { STORE_KEY } from '../store';

const ReduxAnalyticsData5 = <T,>(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mapStateToAnalytics: (state: any, ownProps: T) => AnalyticsDataPayload,
	{ context, ...restConnectOptions }: ConnectOptions = {},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): ((arg1: ComponentType<any>) => ComponentType<any>) =>
	BaseReduxAnalyticsData(mapStateToAnalytics, {
		...restConnectOptions,
		storeKey: STORE_KEY,
	});

const ReduxAnalyticsData8 = <T,>(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mapStateToAnalytics: (state: any, ownProps: T) => AnalyticsDataPayload,
	{ storeKey, ...restConnectOptions }: ConnectOptions = {},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): ((arg1: ComponentType<any>) => ComponentType<any>) =>
	BaseReduxAnalyticsData(mapStateToAnalytics, {
		...restConnectOptions,
		context: IssueTableContext,
	});

export const ReduxAnalyticsData = functionWithCondition(
	() => ff('jff.magma.react-redux-upgrade_53sr4'),
	ReduxAnalyticsData8,
	ReduxAnalyticsData5,
);
